import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { VehiclesCountContainer } from './VehiclesCount.styles';

interface VehicleCountProps {
  count: number;
}

export const VehiclesCount = ({ count }: VehicleCountProps) => {
  // Dependencies
  const { t } = useTranslation();

  return (
    <VehiclesCountContainer>
      {t(count !== 1 ? `listings.vehiclesCount` : `listings.vehicleCount`, {
        count,
      })}
    </VehiclesCountContainer>
  );
};

export default VehiclesCount;
